module.exports = __webpack_public_path__ + "img/shawnee-unsplash.8715bf07.jpg";